import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  CircularProgress,
  Typography,
  Box,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {
  useUpdateProfileMutation,
  useGetProfileDetailsQuery,
} from "../store/services/userApi";
import { toast } from "react-toastify";

const ProfilePage = () => {
  const {
    data: profileData,
    isLoading: isProfileLoading,
    refetch,
  } = useGetProfileDetailsQuery();
  const [updateProfile, { isLoading: isUpdating }] = useUpdateProfileMutation();

  const [formData, setFormData] = useState({
    customer_name: "",
    customer_email: "",
    customer_mobile: "",
    customer_add1: "",
    customer_add2: "",
    city: "",
    state: "",
    pin: "",
    aadhar: "",
    showreportcount: "",
    is_active: true,
  });

  const [profileImage, setProfileImage] = useState(null);

  useEffect(() => {
    if (profileData?.data) {
      const d = profileData.data;
      setFormData({
        customer_name: d.customer_name || "",
        customer_email: d.customer_email || "",
        customer_mobile: d.customer_mobile || "",
        customer_add1: d.customer_add1 || "",
        customer_add2: d.customer_add2 || "",
        city: d.city || "",
        state: d.state || "",
        pin: d.pin?.trim() || "",
        aadhar: d.aadhar || "",
        showreportcount: d.showreportcount || "",
        od_balance: d.parameter.od_balance,
        is_active: true,
      });
      if (d.profile_image) {
        setProfileImage(d.profile_image); // existing image from backend
      }
    }
  }, [profileData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage({
        preview: URL.createObjectURL(file), // live preview
        file, // actual file for backend
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      Object.keys(formData).forEach((key) => data.append(key, formData[key]));

      // send new file only if it exists
      if (profileImage?.file) {
        data.append("profile_image", profileImage.file);
      }

      await updateProfile(data).unwrap();
      toast.success("Profile updated successfully!");
      refetch();
    } catch (err) {
      toast.error("Failed to update profile");
    }
  };

  if (isProfileLoading) return <Typography>Loading profile...</Typography>;

  const inputSx = {
    borderRadius: "0.5rem",
    minWidth: 140,
    "& .MuiOutlinedInput-root": {
      background: "rgba(255,255,255,0.7)",
      "& fieldset": { borderColor: "#E2E8F0" },
      "&:hover fieldset": { borderColor: "#94A3B8" },
    },
    "& .MuiInputLabel-root": { color: "#9333ea !important" },
    "& .MuiInputLabel-root.Mui-disabled": { color: "#9333ea !important" },
    "& .Mui-disabled": {
      "& .MuiOutlinedInput-input": {
        color: "#334155 !important",
        WebkitTextFillColor: "#334155 !important",
      },
      "& .MuiOutlinedInput-notchedOutline": { borderColor: "#CBD5E1" },
    },
  };

  return (
    <Box display="flex" justifyContent="center" mt={4}>
      <Card
        sx={{ maxWidth: 900, width: "100%", boxShadow: 3, borderRadius: 2 }}
      >
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Edit Profile
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid size={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="Customer Name"
                  value={formData.customer_name}
                  onChange={handleInputChange}
                  name="customer_name"
                  slotProps={{ textField: { size: "small" } }}
                  sx={inputSx}
                  disabled
                />
              </Grid>
              <Grid size={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="Customer Email"
                  value={formData.customer_email}
                  name="customer_email"
                  slotProps={{ textField: { size: "small" } }}
                  sx={inputSx}
                  disabled
                />
              </Grid>
              <Grid size={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="Customer Mobile"
                  value={formData.customer_mobile}
                  onChange={handleInputChange}
                  name="customer_mobile"
                  slotProps={{ textField: { size: "small" } }}
                  sx={inputSx}
                  disabled
                />
              </Grid>

              <Grid size={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="Address Line 1"
                  value={formData.customer_add1}
                  onChange={handleInputChange}
                  name="customer_add1"
                  slotProps={{ textField: { size: "small" } }}
                  sx={inputSx}
                  disabled
                />
              </Grid>
              <Grid size={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="Address Line 2"
                  value={formData.customer_add2}
                  onChange={handleInputChange}
                  name="customer_add2"
                  slotProps={{ textField: { size: "small" } }}
                  sx={inputSx}
                  disabled
                />
              </Grid>

              <Grid size={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="City"
                  value={formData.city}
                  onChange={handleInputChange}
                  name="city"
                  slotProps={{ textField: { size: "small" } }}
                  sx={inputSx}
                  disabled
                />
              </Grid>
              <Grid size={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="State"
                  value={formData.state}
                  onChange={handleInputChange}
                  name="state"
                  slotProps={{ textField: { size: "small" } }}
                  sx={inputSx}
                  disabled
                />
              </Grid>
              <Grid size={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="pin Code"
                  value={formData.pin}
                  onChange={handleInputChange}
                  name="pin"
                  slotProps={{ textField: { size: "small" } }}
                  sx={inputSx}
                  disabled
                />
              </Grid>
              {formData.od_balance > 0 && (
                <Grid size={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Od balance"
                    value={formData.od_balance}
                    onChange={handleInputChange}
                    name="pin"
                    slotProps={{ textField: { size: "small" } }}
                    sx={inputSx}
                    disabled
                  />
                </Grid>
              )}

              {/* Profile Image */}
              <Grid size={6}>
                <Button variant="outlined" component="label" size="small">
                  Upload Profile Image
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                </Button>

                {/* Image preview */}
                {profileImage && (
                  <Box sx={{ mt: 2 }}>
                    <img
                      src={
                        profileImage.preview
                          ? profileImage.preview
                          : // : `http://localhost:9000/${profileImage}`
                          `https://onespace.fabmediatech.com/${profileImage}`
                      }
                      alt="Profile"
                      style={{
                        width: 80,
                        height: 80,
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                )}
              </Grid>
            </Grid>

            <Box mt={3}>
              <Button
                type="submit"
                variant="contained"
                disabled={isUpdating}
                size="small"
              >
                {isUpdating ? <CircularProgress size={20} /> : "Save Changes"}
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ProfilePage;
